import { render, staticRenderFns } from "./section-blog.vue?vue&type=template&id=976f7648&scoped=true"
import script from "./section-blog.vue?vue&type=script&lang=js"
export * from "./section-blog.vue?vue&type=script&lang=js"
import style0 from "./section-blog.vue?vue&type=style&index=0&id=976f7648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976f7648",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
